module.exports = __webpack_public_path__ + "img/estalagem16.a4f7955a.jpg";